/**
 * User Appointments
 *
 * @component userappointments
 */

import ClassLogger from 'ClassLogger';
import Api from './_api.js';

class UserAppointments {

    constructor() {
        let self = this;
        self.logger = ClassLogger(self, true);

        if ($('[data-user-appointments]').length === 0) {
            return;
        }
        self.init();
    }

    init() {
        let self = this;
        const url = 'accounts/me/appointments';
        self.getAppointments(url);
        self.preloader($('[data-user-appointments]'), 'show');
    }

    getAppointments(url) {
        let self = this;
        // Request Data
        Api.request('GET', url, '')
            .then(function (response) {

                if (typeof response.data !== 'undefined' && response.data.length > 0) {
                    // the array is defined and has at least one element
                    self.populateAppointments(response.data);
                }

                self.preloader($('[data-user-appointments]'), 'hide');

            }).catch(function (exception) {
                self.logger.error('Processor Error', exception);
                let error_message = 'Es trat ein Fehler auf!';
                if (typeof exception === 'object'
                    && typeof exception.responseJSON === 'object'
                    && typeof exception.responseJSON.error_code !== 'undefined'
                    && typeof exception.responseJSON.error_message === 'string'
                ) {
                    error_message = exception.responseJSON.error_message;
                }
                alert(error_message);

            });

    }

    formatDate(date) {
        // parts stolen from here https://stackoverflow.com/questions/6040515/how-do-i-get-month-and-date-of-javascript-in-2-digit-format
        const startDate = new Date(date);
        const year = startDate.getFullYear();
        const day = (startDate.getDate() < 10 ? '0' : '') + startDate.getDate();
        const month = ((startDate.getMonth() + 1) < 10 ? '0' : '') + (startDate.getMonth() + 1);
        return day + '.' + month + '.' + year;
    }

    formatHours(date) {
        const startDate = new Date(date);
        const hours = (startDate.getHours() < 10 ? '0' : '') + startDate.getHours();
        const minutes = (startDate.getMinutes() < 10 ? '0' : '') + startDate.getMinutes();
        return hours + ':' + minutes;
    }

    populateAppointments(data) {
        let self = this;
        let appointmentOutput = [];
        self.logger.info('Creating appointments...');
        // build output
        data.forEach(element => {
            const eventDate = this.formatDate(element.starton);
            const startTime = this.formatHours(element.starton);
            const endTime = this.formatHours(element.endon);

            //------ Endpoint value testing
            let title = element.company.contactpersons[0].title;
            if (!title) {
                title = '';
            }

            let phoneMarkup = '';
            if (element.company.contactpersons[0].phone) {
                phoneMarkup = `<p class="u-no-margin--bottom">Tel.: ${element.company.contactpersons[0].phone}</p>`;
            }

            let boothlocationMarkup = '';
            if (element.company.boothlocation) {
                boothlocationMarkup = `<div class="cell small-12 medium-auto">
                    <p class="u-no-margin--bottom" ><strong>Standnummer:</strong> <br>${element.company.boothlocation}</p>
                </div >`;
            }

            let jobTitleMarkup = '';
            if (element.job) {
                jobTitleMarkup = `<p class="h6 u-no-margin--bottom u-color--primary">${element.job.title}</p>`;
            }

            //------ Output
            appointmentOutput.push(`<section class="c-user-statistic-card c-user-appointments__item hide">

                    <p class="u-extra-small-margin--bottom"><strong>Wunschtermin:</strong> ${eventDate} von ${startTime} bis ${endTime}</p>
                    ${jobTitleMarkup}
                    <p class="u-extra-small-margin--bottom"><strong>Unternehmen:</strong> ${element.company.name}</p>
                    <p class="u-no-margin--bottom"><strong>Ansprechpartner:</strong></p>
                    <p class="u-extra-small-margin--bottom">${title} ${element.company.contactpersons[0].salutation} ${element.company.contactpersons[0].firstname} ${element.company.contactpersons[0].lastname}</p>
                      ${phoneMarkup}
                    <p class="u-extra-small-margin--bottom">E-Mail: <a href="mailto:${element.company.contactpersons[0].email}">${element.company.contactpersons[0].email}</a></p>

                    <div class="grid-x grid-margin-x">
                        <div class="cell small-12 medium-auto">
                            ${boothlocationMarkup}
                        </div>
                         <div class="cell small-12 medium-auto">
                            <p class="text-right u-no-margin--bottom u-extra-small-margin--top">
                                <a class="c-button c-button--icon c-button--outline c-button--tertiary c-button--small" href="${element.company.profile.uri}">
                                    <span class="c-button__icon-background">
                                        <svg role="presentation" class="c-button__icon u-color--tertiary"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/dist/web/spritesvg#icon-company" href="/assets/dist/web/sprite.svg#icon-company"></use></svg>
                                    </span>
                                    <span class="c-button__label">zum Unternehmen</span>
                                </a>
                            </p>
                        </div>
                    </div>

                    </section>`);
        });

        // print output
        $('[data-user-appointments-output]').append(appointmentOutput);

        // show logic
        if (appointmentOutput.length > 3) {
            // show only first three items
            $('.c-user-appointments__item:nth-child(-n+3)').removeClass('hide');
            // show button
            self.showButton();
        } else {
            // show all
            $('.c-user-appointments__item').removeClass('hide');
        }

    }

    showButton() {
        $('[data-user-appointments-showall]').removeClass('hide').on('click', function (e) {
            e.preventDefault();
            const $appointments = $('[data-user-appointments-showall]');
            // hide and show logic
            $('.c-user-appointments__item:nth-child(n+4)').toggleClass('hide');
            $appointments.toggleClass('is-triggered');

            // button label logic
            if ($appointments.hasClass('is-triggered')) {
                $appointments.find('.c-button__label').text('Weniger anzeigen');
            } else {
                $appointments.find('.c-button__label').text('Alle anzeigen');
            }

        })
    }

    preloader($element, status) {
        let self = this;
        if (status == 'show') {
            $element.find('.c-preloader-overlay').css('display', 'block');
        } else if (status == 'hide') {
            $element.find('.c-preloader-overlay').css('display', 'none');
        }
        self.logger.info('Preloader called');
    }

}

export default new UserAppointments();
